import { Link, useLocation } from "react-router-dom";
import Icon from "./Icon";
import { EMAIL, PHONE } from "../constants/site";
import BrandLogo from "./BrandLogo";

export default function Footer() {
  const { pathname } = useLocation();
  const isContact = pathname === "/contact";

  return (
    <footer className="bg-surface-container-highest border-t border-outline-variant mt-12 md:mt-20">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-gutter page-x py-12 md:py-20 max-w-max-width mx-auto">
        <div>
          <div className="mb-6">
            <BrandLogo
              wrapperClassName="h-24 sm:h-28 w-[12rem] sm:w-[14rem]"
              imageClassName="scale-[2.05]"
            />
          </div>
          <p className="font-body-md text-on-surface-variant">
            {isContact
              ? "Global Online Quran Academy providing spiritual and academic excellence to families worldwide."
              : "An online global platform dedicated to bringing the light of the Quran to every home through expert digital education."}
          </p>
        </div>
        <div>
          <h6 className="font-label-md font-bold text-primary mb-6 uppercase tracking-widest">
            Our Programs
          </h6>
          <ul className="space-y-4">
            <li>
              <Link
                to="/programs/noorani-qaida"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Noorani Qaida
              </Link>
            </li>
            <li>
              <Link
                to="/programs"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Quran Reading
              </Link>
            </li>
            <li>
              <Link
                to="/programs"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Tajweed
              </Link>
            </li>
            <li>
              <Link
                to="/programs/hifz"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Hifz
              </Link>
            </li>
            <li>
              <Link
                to="/programs"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Kids Islamic Studies
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h6 className="font-label-md font-bold text-primary mb-6 uppercase tracking-widest">
            {isContact ? "Quick Links" : "Quick Links"}
          </h6>
          <ul className="space-y-4">
            <li>
              <Link
                to="/"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/academy"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Our Academy
              </Link>
            </li>
            <li>
              <Link
                to="/programs"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Programs
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Pricing
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="text-on-surface-variant hover:text-primary transition-all font-body-md"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h6 className="font-label-md font-bold text-primary mb-6 uppercase tracking-widest">
            {isContact ? "Contact Info" : "Connect With Us"}
          </h6>
          {isContact ? (
            <ul className="space-y-4 font-body-md">
              <li className="flex items-center gap-3 text-on-surface-variant">
                <Icon name="mail" className="text-primary text-sm" />
                {EMAIL}
              </li>
              <li className="flex items-center gap-3 text-on-surface-variant">
                <Icon name="call" className="text-primary text-sm" />
                {PHONE}
              </li>
            </ul>
          ) : (
            <>
              <div className="flex gap-4 mb-6">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-on-primary transition-all"
                  aria-label="Facebook"
                >
                  <Icon name="face_nod" className="text-[20px]" />
                </a>
                <a
                  href={`mailto:${EMAIL}`}
                  className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-on-primary transition-all"
                  aria-label="Email"
                >
                  <Icon name="alternate_email" className="text-[20px]" />
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary hover:bg-primary hover:text-on-primary transition-all"
                  aria-label="YouTube"
                >
                  <Icon name="smart_display" className="text-[20px]" />
                </a>
              </div>
              <div className="bg-surface p-4 rounded-xl border border-outline-variant">
                <p className="font-caption text-on-surface-variant mb-2">
                  Subscribe to our newsletter
                </p>
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="flex gap-2"
                >
                  <input
                    type="email"
                    placeholder="Email address"
                    className="bg-transparent border-none focus:ring-0 text-sm w-full outline-none"
                    aria-label="Email for newsletter"
                  />
                  <button
                    type="submit"
                    className="text-primary"
                    aria-label="Subscribe"
                  >
                    <Icon name="send" />
                  </button>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="max-w-max-width mx-auto page-x py-6 border-t border-outline-variant flex flex-col md:flex-row justify-between items-center gap-4 text-on-surface-variant font-caption text-center md:text-left">
        <p>© 2024 Online Quran Universe. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/contact" className="hover:text-primary transition-all">
            Privacy Policy
          </Link>
          <Link to="/contact" className="hover:text-primary transition-all">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}
